import React, { useEffect } from 'react';
import { HeroSection } from './components/sections/HeroSection';
import { ProblemSections } from './components/sections/ProblemSections';
import { ProductSections } from './components/sections/ProductSections';
import { SocialProofSections } from './components/sections/SocialProofSections';
import { BonusSection } from './components/sections/BonusSection';
import { OfferSections } from './components/sections/OfferSections';
import { FaqFooterSections } from './components/sections/FaqFooterSections';
import { initMetaPixel } from './lib/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <main className="min-h-screen bg-mystic-900 overflow-x-hidden font-sans text-text-primary selection:bg-gold/30 selection:text-white" data-id="element-0">
      {/* Meta Pixel noscript fallback */}
      <noscript data-id="element-1">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1270442961879164&ev=PageView&noscript=1" alt="" data-id="element-2" />
      </noscript>

      <HeroSection data-id="element-3" />
      <ProblemSections data-id="element-4" />
      <ProductSections data-id="element-5" />
      <SocialProofSections data-id="element-6" />
      <BonusSection data-id="element-7" />
      <OfferSections data-id="element-8" />
      <FaqFooterSections data-id="element-9" />
    </main>;
}